module.exports = "<div class=rm-data-loader-panel><div class=\"data-status-caption text-message\">{{getMessage()}}</div></div>";